module.exports = __webpack_public_path__ + "img/button-more.3a28b8bb.png";